// see lesson 27 from “typescript in 50 lessons”
export const neverError = (message: string, token: unknown): Error => {
	return new Error(`${message}. ${token} should not exist.`);
};
